<template>
  <div class="content">
    <!-- 右侧主内容区 -->
    <div class="main-content">
      <div class="table-card">
        <el-table
          :data="tableData"
          border
          stripe
          size="medium"
          style="width: 100%"
        >
          <el-table-column
            prop="id"
            label="序号"
            type="index"
            width="50"
            align="center"
          />
          <el-table-column label="联系人" align="center" width="180">
            <template slot-scope="scope">
              姓名：{{scope.row.nickname}} <br />
              电话：{{scope.row.phone}}<br />
              微信：{{scope.row.wx}}<br />
              地址：{{scope.row.address}}
            </template>
          </el-table-column>
          
          <el-table-column
            prop="institution_name"
            label="机构名称"
            width="120"
            align="center"
          />
          <el-table-column
            prop="institution_nature"
            label="机构性质"
            width="120"
            align="center"
          />
          <el-table-column label="采购版本" align="center" width="120">
            <template slot-scope="scope">
              采购版本{{
                scope.row.level === 1
                  ? "A"
                  : scope.row.level === 2
                  ? "B"
                  : scope.row.level === 3
                  ? "C"
                  : scope.row.level === 4
                  ? "D"
                  : scope.row.level === 5
                  ? "E"
                  : scope.row.level === 6
                  ? "F"
                  : "-"
              }}
            </template>
          </el-table-column>
          <el-table-column label="是否区域独家" align="center" width="120">
            <template slot-scope="scope">
              {{ scope.row.regional_exclusive === "1" ? "是" : "否" }}
            </template>
          </el-table-column>
          <el-table-column label="是否使用品牌" align="center" width="120">
            <template slot-scope="scope">
              {{ scope.row.using_brand === "1" ? "是" : "否" }}
            </template>
          </el-table-column>
          <el-table-column prop="remark" label="备注" align="center" />
          <el-table-column label="访问权限" align="center" width="120">
            <template slot-scope="scope">
              <el-tag v-if="checkAuth1(scope.row.auth_node)">学习权限</el-tag>
              <el-tag v-if="checkAuth2(scope.row.auth_node)">招商权限</el-tag>
            </template>
          </el-table-column>
          <el-table-column label="课件查看权限" align="center" width="120">
            <template slot-scope="scope">
              <el-tag v-if="checkAuth1(scope.row.auth_level)">常规级别</el-tag>
              <el-tag v-if="checkAuth2(scope.row.auth_level)">高端级别</el-tag>
            </template>
          </el-table-column>
          <!-- 状态标签 -->
          <el-table-column label="审核状态" align="center" width="120">
            <template slot-scope="scope">
              <el-tag
                :type="
                  scope.row.audit_status === 0
                    ? 'warning'
                    : scope.row.audit_status === 1
                    ? 'success'
                    : 'danger'
                "
              >
                {{
                  scope.row.audit_status === 0
                    ? "待审核"
                    : scope.row.audit_status === 1
                    ? "已通过"
                    : "已驳回"
                }}
              </el-tag>
            </template>
          </el-table-column>

          <!-- 操作 -->
          <el-table-column label="操作" align="center" width="150">
            <template slot-scope="scope">
              <el-button
                type="text"
                v-if="scope.row.audit_status === 2"
                @click="showRejectDialog(scope.row)"
                >查看驳回原因
              </el-button>
            </template>
          </el-table-column>
        </el-table>

        <!-- 分页直接放在表格下面，同属一个卡片 -->
        <div class="page">
          <el-pagination
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            :current-page="page"
            :page-sizes="[10, 20, 30, 40]"
            :page-size="limit"
            layout="total, sizes, prev, pager, next, jumper"
            :total="total"
          >
          </el-pagination>
        </div>
      </div>
    </div>

    <!-- 驳回原因弹窗 -->
    <el-dialog
      title="驳回原因"
      :visible.sync="rejectDialogVisible"
      width="400px"
      :before-close="handleBeforeClose"
      custom-class="reject-dialog"
      center
    >
      <div class="reject-content">
        {{ rejectReasons }}
      </div>

      <div slot="footer" class="dialog-footer">
        <el-button type="primary" @click="handleComplete">补全资料</el-button>
      </div>
    </el-dialog>

    <!-- 延长有效期 -->
    <el-dialog
      title="延长有效期"
      :visible.sync="periodDialogVisible"
      width="600px"
      :before-close="handlePeriodClose"
      custom-class="reject-dialog"
      center
    >
      <div class="form-item">
        <label class="form-label">延长申请</label>
        <el-input
          type="textarea"
          :rows="2"
          placeholder="请输入延长申请"
          v-model="form.delay_reason"
        >
        </el-input>
      </div>

      <!-- 延长有效期 上传图片（完全按照你给的样式） -->
      <div class="form-item">
        <label class="form-label">上传照片</label>
        <div class="upload-box-list">
          <!-- 已上传的图片 -->
          <div
            v-for="(item, index) in delayImgList"
            :key="index"
            class="upload-box"
          >
            <img :src="item" class="preview-img" />
            <span class="delete-btn" @click.stop="delDelayImg(index)">×</span>
          </div>
          <!-- 上传按钮 -->
          <div class="upload-box add-box" @click="handleDelayUpload">
            <div class="upload-icon">
              <img src="@/assets/picture.png" alt="" />
            </div>
          </div>
        </div>
      </div>

      <div slot="footer" class="dialog-footer">
        <el-button type="primary" @click="determine">确定提交</el-button>
      </div>
    </el-dialog>

    <!-- 隐藏的文件上传框 -->
    <input
      ref="delayFileInput"
      type="file"
      accept="image/*"
      multiple
      style="display: none"
      @change="handleDelayFileChange"
    />
  </div>
</template>

<script>
import { applyList, userDelay, upload } from "@/api/api";

export default {
  name: "index",
  data() {
    return {
      tableData: [],
      page: 1,
      limit: 10,
      total: 0,
      rejectDialogVisible: false,
      rejectReasons: [],
      keyword: "",
      id: "",
      periodDialogVisible: false,
      form: {
        periodId: "",
        delay_reason: "",
      },
      // 延长有效期 上传图片列表
      delayImgList: [],
    };
  },
  mounted() {
    this.applyList();
  },
  methods: {
    checkAuth1(e) {
      let index = e.indexOf("1");
      return index !== -1;
    },
    checkAuth2(e) {
      let index = e.indexOf("2");
      return index !== -1;
    },
    handleSearch(data) {
      this.page = 1;
      this.keyword = data;
      this.applyList();
    },
    validityPeriod(item) {
      this.form.periodId = item.id;
      // 打开弹窗时清空历史数据
      this.form.delay_reason = "";
      this.delayImgList = [];
      this.periodDialogVisible = true;
    },

    // ========== 延长有效期 上传图片 ==========
    handleDelayUpload() {
      this.$refs.delayFileInput.click();
    },
    async handleDelayFileChange(e) {
      const files = e.target.files;
      if (!files.length) return;

      for (let i = 0; i < files.length; i++) {
        const formData = new FormData();
        formData.append("file", files[i]);
        const res = await upload(formData);
        if (res.data.url) {
          this.delayImgList.push(res.data.url);
        }
      }
      // 清空上传框
      e.target.value = "";
    },
    // 删除上传图片
    delDelayImg(index) {
      this.delayImgList.splice(index, 1);
    },

    async determine() {
      if (!this.form.delay_reason) {
        this.$message.warning("请填写延长申请");
        return;
      }
      if (this.delayImgList.length === 0) {
        this.$message.warning("请上传证明材料");
        return;
      }

      // 组装提交数据（图片用逗号拼接）
      const submitData = {
        id: this.form.periodId,
        delay_reason: this.form.delay_reason,
        images: this.delayImgList.join("|"),
      };

      userDelay(submitData).then((res) => {
        this.$message.success(res.info);
        this.periodDialogVisible = false;
        this.applyList();
      });
    },
    applyList() {
      let params = {
        page: this.page,
        limit: this.limit,
        keyword: this.keyword,
      };
      applyList(params).then((res) => {
        this.tableData = res.data.list;
        this.total = res.data.page.total;
      });
    },
    handleSizeChange(val) {
      this.limit = val;
      this.applyList();
    },
    handleCurrentChange(val) {
      this.page = val;
      this.applyList();
    },
    del(id) {
      this.$message.warning("删除成功，ID：" + id);
      this.applyList();
    },
    showRejectDialog(row) {
      this.id = row.id;
      this.rejectReasons = row.reason;
      this.rejectDialogVisible = true;
    },
    handleBeforeClose(done) {
      this.rejectDialogVisible = false;
      done();
    },
    handlePeriodClose(done) {
      this.periodDialogVisible = false;
      done();
    },
    handleComplete() {
      this.$router.push({ path: "/entry", query: { id: this.id } });
    },
  },
};
</script>

<style lang="less" scoped>
.table-card {
  background: #fff;
  border-radius: 8px;
  padding: 20px;
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.05);
}

.page {
  margin-top: 15px;
  text-align: right;
}

.table-img {
  width: 60px;
  height: 60px;
  object-fit: cover;
  border-radius: 4px;
  cursor: pointer;

  &:hover {
    opacity: 0.8;
  }
}

.img-list {
  display: flex;
  gap: 6px;
  flex-wrap: wrap;
  justify-content: center;
}

::v-deep .el-dialog {
  border-radius: 8px;
  min-width: 400px;
}

::v-deep .el-dialog__header {
  border-bottom: 1px solid #eee;
  padding: 16px 20px;
}

::v-deep .el-dialog__title {
  font-weight: 500;
  font-size: 16px;
}

::v-deep .el-dialog__body {
  padding: 20px;
}

.reject-content {
  font-size: 14px;
  line-height: 1.8;

  p {
    margin: 0;
  }
}

::v-deep .el-dialog__footer {
  padding: 16px 20px;
  border-top: 1px solid #eee;
  text-align: center;
}

::v-deep .el-dialog__footer .el-button--primary {
  background: #2f3ced;
  border: none;
  padding: 10px 28px;
  border-radius: 6px;
}

/* 完全匹配你给的上传样式 */
.form-item {
  margin-bottom: 28px;
  display: flex;
  flex-direction: column;
  gap: 12px;

  .form-label {
    font-size: 14px;
    color: #333;
    font-weight: 500;
    text-align: left;
  }
}

.upload-box-list {
  display: flex;
  gap: 20px;
  flex-wrap: wrap;

  .upload-title {
    font-size: 14px;
    font-weight: 500;
    margin-bottom: 10px;
    text-align: left;
  }

  .upload-box {
    width: 120px;
    height: 120px;
    border: 1px dashed #d1d5db;
    border-radius: 6px;
    display: flex;
    align-items: center;
    justify-content: center;
    position: relative;
    cursor: pointer;

    .upload-icon {
      width: 40px;
      height: 40px;

      img {
        width: 100%;
        height: 100%;
        object-fit: cover;
      }
    }

    .preview-img {
      width: 100%;
      height: 100%;
      object-fit: cover;
      border-radius: 6px;
    }

    .delete-btn {
      position: absolute;
      top: -6px;
      right: -6px;
      width: 18px;
      height: 18px;
      background: #f53f3f;
      color: #fff;
      border-radius: 50%;
      display: flex;
      align-items: center;
      justify-content: center;
      font-size: 12px;
      cursor: pointer;
    }
  }

  .add-box {
    border-style: dashed;
    border-color: #ccc;
  }
}
</style>
